import React from "react";
import {Person} from "@src/Interfaces/Entity/Person";
import {inject, observer} from "mobx-react";
import {observable} from "mobx";
import {Values} from "Tools/Values";
import VerifiedUserIcon from '@material-ui/icons/VerifiedUser';
import {Button, Dialog, DialogTitle} from "@material-ui/core";
import RoundButton from "@src/Shared/Components/RoundButton/RoundButton";
import {IAuthStore} from "Stores/Auth/types";
import {STDialogActions, STDialogContent} from "@src/Components/Ui/STDialog";

interface IProps {
    person: Person;
    auth?: IAuthStore;
}

@inject("auth")
@observer
export default class Person2FA extends React.Component<IProps> {
    @observable isOpened: boolean = false;

    handleOpen() {
        this.isOpened = true;
    }

    handleClose() {
        this.isOpened = false;
    }
    
    async handleConfirm() {
        const personId = this.props.person.id;
        const result = await this.props.auth.disablePerson2FA(personId);
        
        if (result) {
            this.handleClose();
        }
    }

    render() {
        return (
            <>
                <RoundButton
                    icon={<VerifiedUserIcon/>}
                    tooltipTitle={Values.getLocalizationValue("2FA")}
                    onClick={() => this.handleOpen()}
                />

                <Dialog
                    maxWidth="sm"
                    open={this.isOpened}
                    onClose={() => this.handleClose()}
                >
                    <DialogTitle>
                        {Values.getLocalizationValue('disable2FA')}
                    </DialogTitle>

                    <STDialogContent>
                        {Values.getLocalizationValue('areYouSureDisablePerson2FA')}?
                    </STDialogContent>

                    <STDialogActions>
                        <Button
                            variant="outlined"
                            color="default"
                            onClick={() => this.handleClose()}
                        >
                            {Values.getLocalizationValue('cancel')}
                        </Button>

                        <Button
                            variant="contained"
                            color="primary"
                            onClick={() => this.handleConfirm()}
                        >
                            {Values.getLocalizationValue('confirm')}
                        </Button>
                    </STDialogActions>
                </Dialog>
            </>
        );
    }


}